import { Grid, Spinner } from "@chakra-ui/react";
import React from "react";

export default function LoadingPage() {
  return (
    <Grid
      w="100%"
      h="100%"
      position="absolute"
      top={0}
      left={0}
      placeItems="center"
      zIndex={99}
      backgroundColor="rgba(211,211,211, 0.1);"
    >
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="blue.500"
        size="lg"
      />
    </Grid>
  );
}
